import { useCallback } from 'react'
import { toast } from '@sales-center/components'

import { useIsUnmounted } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks'
import { addContact, updateContact } from '../api'
import type { ILeadContactUpdate } from '../typings'

export function useCreateUpdateLeadContact() {
  const appDispatch = useAppDispatch()
  const isUnmounted = useIsUnmounted()

  return useCallback(
    async (toSave: ILeadContactUpdate) => {
      try {
        const isUpdate = !!toSave.contact.id
        const action = isUpdate ? updateContact : addContact
        const result = await appDispatch(action(toSave))

        if (isUnmounted()) return

        if (action.fulfilled.match(result)) {
          toast.success(`Contact ${isUpdate ? 'updated' : 'created'}`)
          const { draftAgreementsUpdated } = result.payload.contact
          if (isUpdate && draftAgreementsUpdated) {
            toast.success(
              'Contact information has been updated on any draft agreements.',
            )
          }
        } else if (action.rejected.match(result)) {
          if (result.payload) {
            const { title } = result.payload
            toast.error(`Error: ${title}`)
          } else {
            toast.error(`Error ${isUpdate ? 'updating' : 'creating'} contact`)
          }
        }
      } catch (error) {
        if (error.Message && typeof error.Message === 'string') {
          toast.error(error.Message)
        }
      }
    },
    [appDispatch, isUnmounted],
  )
}
